import styled from 'styled-components';
import colors from 'Styles/colors';

export const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 12px 14px;
  border: 0;
  border-left: 3px solid ${({ theme, $active }) => ($active ? theme.borders.workspaceSelectedItem : 'transparent')};
  background-color: ${({ $active }) => ($active ? colors.blueCeruleanSelected : 'transparent')};
  text-align: left;
  cursor: pointer;

  &:hover {
    background-color: ${({ $active }) => ($active ? colors.blueCeruleanSelected : colors.blueCeruleanHover)};
  }

  @media (max-width: 1024px) {
    width: auto;
    flex: 0 0 auto;
    border-left: 0;
    border-bottom: 3px solid ${({ theme, $active }) => ($active ? theme.borders.workspaceSelectedItem : 'transparent')};
    white-space: nowrap;
  }
`;

export const Icon = styled.span`
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, $active }) => ($active ? theme.borders.workspaceSelectedItem : theme.text.detailModalTabs)};

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  svg path {
    fill: currentColor;
  }
`;

export const Text = styled.span`
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.span`
  font-size: 13.5px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ theme, $active }) => ($active ? theme.text.actionBar : theme.text.detailModalTabs)};
`;

export const SubLabel = styled.span`
  font-size: 11.5px;
  color: ${({ theme }) => theme.text.emptyState};
`;

export const Flag = styled.span`
  flex: 0 0 auto;
  margin-left: auto;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${colors.orange2};
`;
